module.exports = __webpack_public_path__ + "media/images/emoticons/mail-a1d1031c33b674795d3a6b0abe1da93f.gif";